<script>
import { Maps } from 'tortilla';
import { mapGetters } from 'vuex';
import mapStylesDefault from '../vendor/google-map-snazzymaps';
import { 
    createMap, 
    createMarker, 
    createInfoWindow,
} from '../helpers/mapUtils.js';





const communityPopoverContent = (community) => `<div class="amenities__flyout">
    <img alt="${community.name} logo" src="${community.images.logo.thumb}">
</div>`;
export default {
    props: {
        community: {type: Object, required: true},
        availableAmenities: {type: Array, required: true}
    },
    data: () => ({
        mapStyles: mapStylesDefault,
        communityMarkers: [],
        amenityMarkers: [],
        mergedMarkers: [],
        amenity: '',
        query: '',
        gm: undefined,
        placesService: undefined,
        mapInstance: undefined,
        infoWindow: undefined,
        enableInfoWindow: true,
        isFilterPanelActive: false,
        isReady: false,
        enabled: true, // work-around - prevent searches until previous is complete
        icons: {
            community: '/images/site/maps/pin-rental.svg',
            place: '/images/site/maps/pin-amenity.svg'
        },
        store: {},
        localStore: {}
    }),
    computed: {
        markers() {
            return this.mergedMarkers;
        },
        communityPosition() {
            return {
                lat: parseFloat(this.community.latitude),
                lng: parseFloat(this.community.longitude)
            };
        },
        communityIcon() {
            return {
                url: this.icons.community,
                scaledSize: new this.gm.Size(32, 44)
            };
        },
        placeIcon() {
            return {
                url: this.icons.place,
                scaledSize: new this.gm.Size(28, 28)
            };
        },
        selectedAmenity() {
            return parseInt(this.amenity, 10);
        },
        ...mapGetters({
            appData: 'app/getData'
        })
    },
    watch: {
        amenity(val) {
            if (this.gm) {
                this.isFilterPanelActive = false;
                if (this.enableInfoWindow && this.infoWindow) {
                    this.infoWindow.close();
                }
                this.amenityMarkers.forEach((marker) => marker.map = null);
                this.amenityMarkers = [];
                this.enabled = false;
                this.getAmenities();
            }
        }
    },
    created() {
        this.getPlacesFromLocalStore();
        document.addEventListener('readystatechange', this.handleStateChange, false);
    },
    mounted() {
        // No more state changes before mounted
        events.$on("map-intialized", (map) => {
           
            this.useMap();
            if (document.readyState === 'complete' && !this.mapInstance) {
                document.removeEventListener('readystatechange', this.handleStateChange);
            }
         
        });
        
    },
    beforeDestroy() {
        document.removeEventListener('readystatechange', this.handleStateChange);
    },
    methods: {
        getPlacesFromLocalStore() {
            const localStore = localStorage.getItem(`amenities_${this.community.id}`);
            this.localStore = JSON.parse(localStore) || {};
        },
        handleStateChange() {
            if (document.readyState === 'complete') {
                this.useMap();
                document.removeEventListener('readystatechange', this.handleStateChange);
            }
        },
       async useMap() {

            this.gm = google.maps;
            this.mapInstance = await createMap('mapAmmenities', {
                center: {
                    lat: parseFloat(this.community.latitude),
                    lng: parseFloat(this.community.longitude)
                },
                zoom: 10,
                // styles: this.mapStyles
            });
            this.placesService = new this.gm.places.PlacesService(this.mapInstance, this.communityPosition);
                this.initCommunityMarker();
                this.mergedMarkers = [...this.communityMarkers];
            if (this.enableInfoWindow) {
                    // this.infoWindow = new this.gm.InfoWindow({maxWidth: 350});
                this.infoWindow = createInfoWindow({
                    maxWidth: 350
                });
                // this.gm.event.addListener(this.infoWindow, 'domready', this.setInfoWindowStyle);
            }
            // this.initClusterer();
            // this.loaded = true;
            // this.$gmaps().then((gm) => {
            //     this.gm = gm;
            //     this.placesService = new gm.places.PlacesService(this.mapInstance, this.communityPosition);
            //     this.initCommunityMarker();
            //     this.mergedMarkers = [...this.communityMarkers];

            //     if (this.enableInfoWindow) {
            //         this.infoWindow = new this.gm.InfoWindow({maxWidth: 350});
            //         this.gm.event.addListener(this.infoWindow, 'domready', this.setInfoWindowStyle);
            //     }
            // });
        },
        initMap(map) {
            this.mapInstance = map;
            this.isReady = true;
        },
       async initCommunityMarker() {
            // const marker = new this.gm.Marker({
            //     map: this.mapInstance,
            //     optimized: false,
            //     zIndex: 100,
            //     content: communityPopoverContent(this.community),
            //     icon: this.communityIcon,
            //     position: this.communityPosition
            // });
            const marker = await createMarker({
                    map: this.mapInstance,
                    position: this.communityPosition,
                    size:{ width: 30, height: 40  },
                    icon: this.communityIcon.url,
                    title: this.community.property_type_title,
                    className: 'custom-marker',
                    id: `marker_${this.community.id}` 
                });
            marker.addListener('click', () => {
                if (this.enableInfoWindow) {
                    this.infoWindow.close();
                    this.infoWindow.setContent(communityPopoverContent(this.community));
                    this.infoWindow.open(this.mapInstance, marker);
                }
                // this.mapInstance.panTo(marker.position);
            });
            this.communityMarkers.push(marker);
        },
        getAmenities() {

            this.query = this.availableAmenities[this.amenity].search;
            const query = this.query + '';
            const amenity = this.amenity + '';
            if (this.localStore && this.localStore[query]) {
                this.localStore[query].forEach(async (amenityData) => {
                    const template = this.getTemplate(amenityData);
                    // const marker = new this.gm.Marker({
                    //     map: this.mapInstance,
                    //     icon: this.placeIcon,
                    //     title: amenityData.title,
                    //     query: query,
                    //     amenity: amenity,
                    //     position: amenityData.position,
                    //     address: amenityData.address
                    // });

                    const marker = await createMarker({
                        map: this.mapInstance,
                        position: amenityData.position,
                        size:{ width: 30, height: 40  },
                        icon: this.placeIcon.url,
                        title: amenityData.title,
                        className: 'custom-marker',
                        id: `marker_${amenityData.place_id}` 
                    }); 
                    marker.addListener('click', () => {
                        if (this.enableInfoWindow) {
                            this.infoWindow.close();
                            this.infoWindow.setContent(template);
                            this.infoWindow.open(this.mapInstance, marker);
                        }
                        // this.mapInstance.panTo(marker.position);
                    });
                    this.amenityMarkers.push(marker);
                });

                this.mergedMarkers = [...this.communityMarkers, ...this.amenityMarkers];
                this.enabled = true;
            } else {
                const amenityRequest = {
                    location: this.communityPosition,
                    radius: '8047', // ~5 miles (it's in meters)
                    // type: query.split(' ') // If doing a nearbySearch()
                    query: query // If doing a textSearch
                };

                this.localStore[query] = [];
                this.placesService.textSearch(amenityRequest, (places, status) => {
                    let loaded = 0;
                    if (status === this.gm.places.PlacesServiceStatus.OK) {
                        console.log('places', places);
                        places.forEach(async (place, index) => {
                            const amenityData = {
                                title: place.name,
                                address: place.formatted_address,
                                place_id: place.place_id,
                                position: {
                                    lat: place.geometry.location.lat(),
                                    lng: place.geometry.location.lng()
                                }
                            };
                            const template = this.getTemplate(amenityData);
                              // const marker = new this.gm.Marker({
                            //     map: this.mapInstance,
                            //     icon: this.placeIcon,
                            //     title: amenityData.title,
                            //     query: query,
                            //     amenity: amenity,
                            //     position: amenityData.position,
                            //     address: amenityData.address
                            // });
                            const marker = await createMarker({
                                map: this.mapInstance,
                                position: amenityData.position,
                                size:{ width: 30, height: 30 },
                                icon: this.placeIcon.url,
                                title: amenityData.title,
                                className: 'custom-marker',
                                id: `marker_${amenityData.place_id}` 
                            }); 
                          
                            marker.addListener('click', () => {
                                if (this.enableInfoWindow) {
                                    this.infoWindow.close();
                                    this.infoWindow.setContent(template);
                                    this.infoWindow.open(this.mapInstance, marker);
                                }
                                // this.mapInstance.panTo(marker.position);
                            });

                            this.localStore[query].push(amenityData);
                            localStorage.setItem(`amenities_${this.community.id}`, JSON.stringify(this.localStore));
                            this.amenityMarkers.push(marker);
                            this.mergedMarkers = [...this.communityMarkers, ...this.amenityMarkers];
                            this.enabled = true;
                        });
                    }
                });
            }
        },
        setInfoWindowStyle() {
            const infoWindowOuter = $('.gm-style-iw');
            const infoWindowBkgd = infoWindowOuter.prev();
            const infoWindowTail = infoWindowBkgd.children(':nth-child(3)');

            // Hide the shadows
            infoWindowBkgd.children(':nth-child(2)').css({display: 'none'});
            infoWindowBkgd.children(':first-child').css({display: 'none'});

            // Style the background
            infoWindowBkgd.children(':nth-child(4)').css({
                boxShadow: '0 0 14px 0 rgba(0,0,0,0.2)',
                borderRadius: '0'
            });

            // Tail
            infoWindowTail.css({
                transformOrigin: 'top center',
                transform: 'scale(0.7, 0.75)'
            });
            infoWindowTail.find('div').children().css({
                backgroundColor: '#092a49'
            });
        },
        getTemplate(place) {
            const addressTemplate = place.formatted_address
                ? `<div class="amenities__flyout-address"><a href="https://www.google.com/maps/search/?api=1&query=${encodeURI(place.address)}&query_place_id=${place.place_id}" target="_blank">${place.address}</a></div>`
                : '';
            return `<div class="amenities__flyout">
                <div class="amenities__flyout-header">${place.title}</div>
                <div class="amenities__flyout-body">
                    ${addressTemplate}
                </div>
            </div>`;
        }
    }
};
</script>

<style>
    #mapAmmenities {
        height: 100%;
         width: 100%; 
        position: absolute !important;
        z-index: 1;
    }
</style>
